import { merchantApi } from '@/config/axios'

export const getCommentPage = (params: any) =>
  merchantApi.get({ url: '/merchant-api/product/comment/page', params })

export const replyComment = (data: { id: number; replyContent: string }) =>
  merchantApi.put({ url: '/merchant-api/product/comment/reply', data })
